var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetroIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 40,
    viewBox: "0 0 160 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9178 26.4035H11.866V14.6856H16.3383C18.9993 14.6856 20.5542 16.0322 20.5542 18.3405C20.5542 19.9114 19.8168 21.0335 18.4382 21.5945L20.6664 26.4035H18.4222L16.4345 22.0273H13.9178V26.4035ZM13.9178 16.5131V20.216H16.3383C17.6367 20.216 18.4062 19.5267 18.4062 18.3405C18.4062 17.1703 17.6367 16.5131 16.3383 16.5131H13.9178Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0846 26.4035H23.807V14.6856H31.0846V16.5772H25.8588V19.5908H30.5395V21.4022H25.8588V24.512H31.0846V26.4035Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4854 16.5772V14.6856H42.398V16.5772H38.9676V26.4035H36.9158V16.5772H33.4854Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2205 26.4035H45.1687V14.6856H49.641C52.302 14.6856 53.8569 16.0322 53.8569 18.3405C53.8569 19.9114 53.1195 21.0335 51.7409 21.5945L53.9691 26.4035H51.7249L49.7372 22.0273H47.2205V26.4035ZM47.2205 16.5131V20.216H49.641C50.9394 20.216 51.7089 19.5267 51.7089 18.3405C51.7089 17.1703 50.9394 16.5131 49.641 16.5131H47.2205Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7237 26.4035V14.6856H89.3884C91.6967 14.6856 93.1073 15.8879 93.1073 17.8435C93.1073 19.142 92.5302 20.0717 91.4242 20.5366C92.6585 20.9373 93.2836 21.867 93.2836 23.2296C93.2836 25.2333 91.889 26.4035 89.4685 26.4035H84.7237ZM89.2121 16.497H86.7755V19.687H89.2601C90.3822 19.687 91.0074 19.0939 91.0074 18.0519C91.0074 17.042 90.3662 16.497 89.2121 16.497ZM89.3884 21.4182H86.7755V24.5921H89.3884C90.5425 24.5921 91.1837 24.0311 91.1837 22.9731C91.1837 21.9792 90.5265 21.4182 89.3884 21.4182Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4191 26.4035H96.3673V14.6856H100.84C103.501 14.6856 105.055 16.0322 105.055 18.3405C105.055 19.9114 104.318 21.0335 102.94 21.5945L105.168 26.4035H102.923L100.936 22.0273H98.4191V26.4035ZM98.4191 16.5131V20.216H100.84C102.138 20.216 102.907 19.5267 102.907 18.3405C102.907 17.1703 102.138 16.5131 100.84 16.5131H98.4191Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.36 14.6856V26.4035H108.308V14.6856H110.36Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.376 26.4035H114.16V14.6856H118.263C121.726 14.6856 124.114 17.0741 124.114 20.5686C124.114 24.015 121.774 26.4035 118.376 26.4035ZM118.071 16.5772H116.212V24.512H118.183C120.524 24.512 121.95 23.0052 121.95 20.5686C121.95 18.084 120.492 16.5772 118.071 16.5772Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M132.357 16.4169C130.033 16.4169 128.703 18.1 128.703 20.6327C128.703 23.2456 130.209 24.6723 132.374 24.6723C134.409 24.6723 135.644 23.5502 135.644 21.6747V21.6266H132.101V19.8152H137.551V26.4035H135.82L135.692 25.057C135.051 25.9547 133.72 26.5798 132.133 26.5798C128.847 26.5798 126.555 24.1914 126.555 20.5846C126.555 17.026 128.879 14.4933 132.406 14.4933C135.083 14.4933 137.15 16.0482 137.487 18.4366H135.323C134.954 17.0581 133.768 16.4169 132.357 16.4169Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M148.732 26.4035H141.454V14.6856H148.732V16.5772H143.506V19.5908H148.187V21.4022H143.506V24.512H148.732V26.4035Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5346 15.5763C63.2831 15.5763 58.2152 20.4238 58.2152 26.4035H56.3672C56.3672 19.4475 62.2624 13.8086 69.5346 13.8086C76.8068 13.8086 82.702 19.4475 82.702 26.4035H80.8539C80.8539 20.4238 75.7861 15.5763 69.5346 15.5763Z",
    fill: "url(#paint0_linear_7868_14195)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7868_14195",
    x1: 56.3672,
    y1: 23.541,
    x2: 82.702,
    y2: 23.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CBAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8A8FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetroIcon);
export default __webpack_public_path__ + "static/media/retroIcon.17d97c7729f04cf81f2b692824fef73a.svg";
export { ForwardRef as ReactComponent };